module.exports = __webpack_public_path__ + "static/media/Won.a4aa87a5.wav";